import { render, staticRenderFns } from "./moveStructureTree.vue?vue&type=template&id=56e5c84c&"
import script from "./moveStructureTree.vue?vue&type=script&lang=js&"
export * from "./moveStructureTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports